import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDre3bxEyQ1_ivBnoW0Q7ki5Ky7RJEWDYA",
  authDomain: "dulia.us",
  projectId: "saintapp-32563",
  storageBucket: "saintapp-32563.firebasestorage.app",
  messagingSenderId: "156178937020",
  appId: "1:156178937020:web:57ae4a0937c72b79954cb9",
  measurementId: "G-RKJDTL1WJB",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
